import React from 'react';
import styles from './CardContainer.module.css';

export default ({ title, subTitle, children, isAutobookPage, titleRight }) => {
  return (
    <div className={styles.container}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span
          style={{ fontSize: isAutobookPage ? '16px' : '20px' }}
          className={styles.title}>
          {title}
        </span>
        <span>{titleRight && titleRight}</span>
      </div>
      {subTitle && (
        <span
          style={{ fontSize: isAutobookPage ? '14px' : '16px' }}
          className={styles.subTitle}>
          {subTitle}
        </span>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
};
